import parseHeader from "./parseHeader";

const transformLinkHeader = (action, state, res) =>
  res.json().then((json) => ({
    data: json,
    loadMoreUrl: parseHeader(res.headers.get("Link")),
  }));

export default transformLinkHeader;
